import { Component } from '@angular/core';

@Component({
  selector: 'spark-authenticated',
  templateUrl: './authenticated.component.html'
})
export class AuthenticatedComponent {
  constructor() {}
}
